/* ============================================================
   Ascend - PEScience layout enhancements
   ============================================================ */
(function () {
  'use strict';
  var RED = '#f0432b';

  function buyNowGo(variantId) {
    var f = document.createElement('form');
    f.method = 'POST'; f.action = '/cart/add'; f.style.display = 'none';
    f.innerHTML = '<input type="hidden" name="id" value="' + variantId + '"><input type="hidden" name="quantity" value="1"><input type="hidden" name="return_to" value="/checkout">';
    document.body.appendChild(f); f.submit();
  }

      function styleBuyBtn(btn) {
    btn.classList.add('ascend-card-buynow');
    btn.style.cssText =
      'display:flex;align-items:center;justify-content:center;text-align:center;' +
      'width:100%;min-height:54px;margin:0;padding:10px 14px;border:1.5px solid ' + RED +
      ';border-radius:8px;background:transparent;color:' + RED +
      ';font-weight:700;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;' +
      'font-size:13px;line-height:1.15;transition:background .18s ease,color .18s ease;';
    btn.onmouseenter = function () { btn.style.background = 'rgba(240,67,43,.08)'; };
    btn.onmouseleave = function () { btn.style.background = 'transparent'; };
  }

     function addBuyNow() {
    // keep the button block matched to the product's text column (load + resize)
    function alignCta(cta) {
      var cardEl = cta.parentElement;
      var info = cardEl && cardEl.querySelector('.card-information');
      if (!cardEl || !info) return;
      var cb = cardEl.getBoundingClientRect(), ib = info.getBoundingClientRect();
      cta.style.paddingLeft = Math.max(0, Math.round(ib.left - cb.left)) + 'px';
      cta.style.paddingRight = Math.max(0, Math.round(cb.right - ib.right)) + 'px';
      var content = cardEl.querySelector('.card__content');
      if (content) cta.style.paddingBottom = getComputedStyle(content).paddingBottom;
    }
    if (!window.__ascCtaResize) {
      window.__ascCtaResize = true;
      window.addEventListener('resize', function () {
        [].slice.call(document.querySelectorAll('.ascend-cta')).forEach(alignCta);
      });
    }

    [].slice.call(document.querySelectorAll('.card-wrapper')).forEach(function (card) {
      if (card.__ascBuy) return;

      // Only real product cards link to /products/. Category/collection tiles skip.
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      card.__ascBuy = true;

      var cardEl = card.querySelector('.card') || card;
      var form = card.querySelector('form[action*="/cart"]');
      var idEl = form ? form.querySelector('[name="id"]') : null;

      // clear anything we previously managed (idempotent)
      [].slice.call(card.querySelectorAll('.ascend-cta, button, a')).forEach(function (b) {
        if (b.classList && b.classList.contains('ascend-cta')) { b.remove(); return; }
        if (/^\s*(buy now|one time purchase|subscribe\s*(&|and)\s*save)\s*$/i.test(b.textContent || '')) { b.remove(); }
      });

      // hide the theme's redundant "Add to cart"
      var atc = [].slice.call(card.querySelectorAll('button, input[type=submit], a.button, .quick-add__submit')).find(function (b) {
        var t = (b.textContent || b.value || '');
        return /add to cart|sold out|choose options|\+ add/i.test(t);
      });
      if (atc) { atc.style.display = 'none'; }

      // build the two-button block
      var wrap = document.createElement('div');
      wrap.className = 'ascend-cta';
      wrap.style.cssText = 'display:flex;flex-direction:column;gap:10px;margin-top:auto;width:100%;box-sizing:border-box;padding-top:12px;position:relative;z-index:3;';

      // 1) One Time Purchase -> product page, preselect one-time (same PDP as Subscribe)
      var oneTime = document.createElement('button');
      oneTime.type = 'button';
      oneTime.textContent = 'One Time Purchase';
      styleBuyBtn(oneTime);
      oneTime.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var href = link.getAttribute('href');
        window.location.href = href + (href.indexOf('?') > -1 ? '&' : '?') + 'onetime=1#subscribe';
      });

      // 2) Subscribe & Save -> product page (Appstle picker: plan + frequency)
      var sub = document.createElement('button');
      sub.type = 'button';
      sub.textContent = 'Subscribe & Save';
      styleBuyBtn(sub);
      sub.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var href = link.getAttribute('href');
        window.location.href = href + (href.indexOf('?') > -1 ? '&' : '?') + 'subscribe=1#subscribe';
      });

      wrap.appendChild(oneTime);
      wrap.appendChild(sub);

      // pin to the bottom of the equal-height card so rows always line up
      cardEl.style.display = 'flex';
      cardEl.style.flexDirection = 'column';
      cardEl.appendChild(wrap);
      alignCta(wrap);
    });
  }

  function measureTub(imgEl) {
    return new Promise(function (res) {
      var url = imgEl.currentSrc || imgEl.src;
      if (!url) { res(null); return; }
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var nw = im.naturalWidth || 160, nh = im.naturalHeight || 160;
          var w = Math.min(160, nw), h = Math.max(1, Math.round(nh * (w / nw)));
          var c = document.createElement('canvas'); c.width = w; c.height = h;
          var ctx = c.getContext('2d'); ctx.drawImage(im, 0, 0, w, h);
          var d = ctx.getImageData(0, 0, w, h).data;
          var top = h, bot = 0;
          for (var y = 0; y < h; y++) {
            var row = false;
            for (var x = 0; x < w; x++) {
              var i = (y * w + x) * 4;
              if (d[i + 3] > 20 && !(d[i] > 238 && d[i + 1] > 238 && d[i + 2] > 238)) { row = true; break; }
            }
            if (row) { if (y < top) top = y; if (y > bot) bot = y; }
          }
          res(bot > top ? { topF: top / h, botF: bot / h } : null);
        } catch (e) { res(null); }
      };
      im.onerror = function () { res(null); };
      im.src = url;
    });
  }

  var TUB_TOP = 0.15;
  var TUB_H = 0.70;
  function normalizeTubs() {
    var jobs = [].slice.call(document.querySelectorAll('.card-wrapper')).map(function (card) {
      if (card.__ascTub) return null;
      var img = card.querySelector('.card__inner img, .card__media img, img');
      return img ? { card: card, img: img } : null;
    }).filter(Boolean);
    if (!jobs.length) return;
    Promise.all(jobs.map(function (j) { return measureTub(j.img); })).then(function (data) {
      jobs.forEach(function (j, i) {
        var m = data[i];
        if (!m) return;
        var hF = m.botF - m.topF;
        if (hF <= 0) return;
        j.card.__ascTub = true;
        var scale = Math.max(0.7, Math.min(1.15, TUB_H / hF));
        var dyPct = (TUB_TOP - m.topF * scale) * 100;
        j.img.style.transformOrigin = '50% 0%';
        j.img.style.transform = 'translateY(' + dyPct.toFixed(2) + '%) scale(' + scale.toFixed(4) + ')';
      });
    });
  }

  function injectSubscribeCSS() {
    if (document.getElementById('ascend-sub-css')) return;
    var s = document.createElement('style');
    s.id = 'ascend-sub-css';
    s.textContent =
      '.appstle_subscription_wrapper{border:0!important;background:transparent!important;padding:0!important;margin:14px 0 4px!important;}' +
      '.appstle_subscription_wrapper_option{border:1.5px solid rgba(128,128,128,.3)!important;border-radius:14px!important;padding:16px 18px!important;margin:0 0 10px!important;transition:border-color .18s ease,background .18s ease;}' +
      '.appstle_subscription_wrapper_option:hover{border-color:' + RED + '!important;}' +
      '.appstle_subscription_wrapper_option.appstle-selected-option,.appstle_subscription_wrapper_option:has(input:checked){border-color:' + RED + '!important;background:rgba(240,67,43,.06)!important;}' +
      '.appstle_subscription_save,.appstle_subscription_element .appstle_subscription_save{background:' + RED + '!important;color:#fff!important;border-radius:20px!important;padding:2px 10px!important;font-weight:700!important;}';
    (document.head || document.documentElement).appendChild(s);
  }

  // NOTE: previously a fixSubscribeCopy() here rewrote the Appstle widget's real
  // "10%/15%" discount text to "25%" purely cosmetically — the checkout still applied
  // the real (lower) selling plan, so the page advertised a discount it did not honor.
  // Removed 2026-09-24: the real Subscribe & Save discount must be set to 25% in the
  // Appstle app so the widget shows the genuine plan.

  function buildInstagramSection() {
    if (document.getElementById('ascend-social')) return;
    var IG = 'https://www.instagram.com/ascendsupps/';
    var reels = [
      { c: 'DZthGGCTupy', tx: -340, ty: -34, rot: -16 },
      { c: 'DZdKJkHT_k7', tx: -196, ty: 58, rot: -7 },
      { c: 'DWpl1UgzgnE', tx: -58, ty: -64, rot: 3 },
      { c: 'DZcv8eiTqWI', tx: 96, ty: 52, rot: 9 },
      { c: 'DYP4LA4h_y_', tx: 238, ty: -40, rot: -6 },
      { c: 'DZsx0NvSBNV', tx: 368, ty: 62, rot: 16 }
    ];
    var cards = reels.map(function (r, i) {
      var r0 = ((i - 2.5) * 2.2).toFixed(1);
      return '<a href="https://www.instagram.com/reel/' + r.c + '/" target="_blank" rel="noopener" class="deck-card" style="--tx:' + r.tx + 'px;--ty:' + r.ty + 'px;--rot:' + r.rot + 'deg;--r0:' + r0 + 'deg;z-index:' + (i + 1) + ';">' +
        '<iframe src="https://www.instagram.com/reel/' + r.c + '/embed/" loading="lazy" scrolling="no" tabindex="-1" title="Ascend reel" style="position:absolute;top:-56px;left:50%;width:344px;height:700px;transform:translateX(-50%);border:0;pointer-events:none;"></iframe>' +
        '<span class="dc-mask-t"></span><span class="dc-mask-b"></span>' +
        '<span class="dc-tag"><svg width="14" height="14" viewBox="0 0 24 24" fill="#fff" aria-hidden="true"><path d="M12 2.2c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.42.56.22.96.48 1.38.9.42.42.68.82.9 1.38.17.42.37 1.06.42 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.42 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.17-1.06.37-2.23.42-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.42-.56-.22-.96-.48-1.38-.9-.42-.42-.68-.82-.9-1.38-.17-.42-.37-1.06-.42-2.23C2.21 15.58 2.2 15.2 2.2 12s.01-3.58.07-4.85c.05-1.17.25-1.8.42-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.17 1.06-.37 2.23-.42C8.42 2.21 8.8 2.2 12 2.2m0 4.13a5.67 5.67 0 100 11.34 5.67 5.67 0 000-11.34m0 1.62a4.05 4.05 0 110 8.1 4.05 4.05 0 010-8.1m5.16-2.9a.95.95 0 110 1.9.95.95 0 010-1.9"/></svg> @ascendsupps</span>' +
      '</a>';
    }).join('');

    var st = document.createElement('style');
    st.setAttribute('data-ascend-social-style', '');
    st.textContent =
      '#ascend-social .uppercase{text-transform:uppercase;}' +
      '#ascend-social .font-heading{font-family:var(--font-heading-family,inherit);font-weight:800;}' +
      '#ascend-social .font-body{font-family:var(--font-body-family,inherit);}' +
      '#ascend-social .font-label{font-family:var(--font-body-family,inherit);font-weight:700;}' +
      '#ascend-social .text-ember{color:#f0432b;}' +
      '#ascend-social .text-metallic{background:linear-gradient(180deg,#fff,#b7b7c2);-webkit-background-clip:text;background-clip:text;color:transparent;}' +
      '#ascend-social .deck-stage{position:relative;width:100%;max-width:1100px;margin:26px auto 0;height:600px;}' +
      '#ascend-social .deck{position:absolute;top:0;left:0;width:100%;height:600px;transform-origin:top center;}' +
      '#ascend-social .deck-card{position:absolute;top:50%;left:50%;width:264px;height:432px;margin:-216px 0 0 -132px;border-radius:22px;overflow:hidden;background:#0c0c11;border:1px solid rgba(255,255,255,.14);box-shadow:0 34px 66px -24px rgba(0,0,0,.9);text-decoration:none;transform:rotate(var(--r0));transition:transform 1.05s cubic-bezier(.2,.85,.25,1),box-shadow .45s ease,border-color .45s ease;will-change:transform;}' +
      '#ascend-social .deck-card.out{transform:translate(var(--tx),var(--ty)) rotate(var(--rot));}' +
      '#ascend-social .deck-card.out:hover{transform:translate(var(--tx),var(--ty)) rotate(0deg) scale(1.07);box-shadow:0 44px 84px -22px rgba(240,67,43,.6);border-color:rgba(240,67,43,.6);z-index:60;}' +
      '#ascend-social .dc-mask-t{position:absolute;left:0;right:0;top:0;height:70px;background:linear-gradient(#0c0c11,rgba(12,12,17,0));pointer-events:none;}' +
      '#ascend-social .dc-mask-b{position:absolute;left:0;right:0;bottom:0;height:122px;background:linear-gradient(rgba(12,12,17,0),#0c0c11 78%);pointer-events:none;}' +
      '#ascend-social .dc-tag{position:absolute;left:13px;bottom:13px;display:inline-flex;align-items:center;gap:6px;color:#fff;font-size:12px;font-weight:600;text-shadow:0 1px 5px rgba(0,0,0,.7);pointer-events:none;}' +
      '@keyframes ascLive{0%,100%{transform:scale(1);opacity:1;}50%{transform:scale(1.35);opacity:.55;}}' +
      '#ascend-social .ig-live{width:8px;height:8px;border-radius:50%;background:#f0432b;display:inline-block;animation:ascLive 1.6s infinite;box-shadow:0 0 12px 2px rgba(240,67,43,.6);}' +
      '#ascend-social .ig-follow:hover{transform:translateY(-2px);box-shadow:0 14px 30px -8px rgba(240,67,43,.6);}' +
      '#ascend-social .ig-allbtn:hover{background:#f0432b;color:#fff;border-color:#f0432b;}';
    (document.head || document.documentElement).appendChild(st);

    var sec = document.createElement('section');
    sec.id = 'ascend-social';
    sec.style.cssText = 'position:relative;padding:100px 24px;background:radial-gradient(120% 80% at 50% 0%, #14141b 0%, #0a0a0e 60%);';
    sec.innerHTML =
      '<div style="max-width:1200px;margin:0 auto;">' +
        '<div style="text-align:center;margin-bottom:14px;">' +
          '<span class="font-label uppercase" style="font-size:12px;letter-spacing:.5em;color:#f0432b;display:inline-flex;align-items:center;gap:9px;"><span class="ig-live"></span> Follow us on Instagram and be part of the journey</span>' +
          '<p class="font-body" style="color:#9a9aa5;max-width:40rem;margin:16px auto 0;font-size:15px;line-height:1.6;">See what the <strong style="color:#fff;">43K+</strong> strong Ascend community is training with on <strong style="color:#fff;">@ascendsupps</strong>.</p>' +
        '</div>' +
        '<div style="display:flex;align-items:center;justify-content:center;gap:16px;margin:24px 0 44px;flex-wrap:wrap;">' +
          '<div style="display:flex;align-items:center;gap:12px;">' +
            '<div style="width:56px;height:56px;border-radius:50%;padding:2px;background:linear-gradient(45deg,#f0432b,#f9a825,#e1306c);">' +
              '<img src="https://ascendsupplement.myshopify.com/cdn/shop/files/0.png" alt="@ascendsupps" style="width:100%;height:100%;border-radius:50%;background:#0a0a0e;object-fit:contain;padding:6px;box-sizing:border-box;display:block;">' +
            '</div>' +
            '<div style="text-align:left;"><div style="color:#fff;font-weight:700;font-size:15px;">@ascendsupps</div><div style="color:#9a9aa5;font-size:12px;">Ascend Supplements &middot; 43.9K followers</div></div>' +
          '</div>' +
          '<a href="' + IG + '" target="_blank" rel="noopener" class="ig-follow font-label uppercase" style="display:inline-flex;align-items:center;gap:8px;height:46px;padding:0 28px;border-radius:9px;background:#f0432b;color:#fff;font-size:12px;letter-spacing:.2em;text-decoration:none;transition:transform .4s ease, box-shadow .4s ease;">Follow &rarr;</a>' +
        '</div>' +
        '<div class="deck-stage"><div class="deck">' + cards + '</div></div>' +
        '<div style="text-align:center;margin-top:46px;">' +
          '<a href="' + IG + '" target="_blank" rel="noopener" class="ig-allbtn font-label uppercase" style="display:inline-flex;align-items:center;gap:10px;height:52px;padding:0 34px;border-radius:9px;border:1px solid rgba(255,255,255,.28);color:#fff;font-size:12px;letter-spacing:.24em;text-decoration:none;transition:background .35s ease,color .35s ease,border-color .35s ease;">View all on Instagram &rarr;</a>' +
        '</div>' +
      '</div>';

    var subSec = document.querySelector('[id$="__subscribe_save"]')
      || [].slice.call(document.querySelectorAll('.shopify-section')).find(function (s) {
        return /^\s*subscribe\s*&\s*save\s*$/i.test(((s.querySelector('h2,h3,.title') || {}).textContent || '').trim());
      });
    if (subSec && subSec.parentNode) {
      subSec.parentNode.insertBefore(sec, subSec.nextElementSibling);
    } else {
      var footEl = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');
      if (footEl && footEl.parentNode) footEl.parentNode.insertBefore(sec, footEl);
      else document.body.appendChild(sec);
    }

    var deck = sec.querySelector('.deck');
    var stage = sec.querySelector('.deck-stage');
    function sizeDeck() {
      var vw = document.documentElement.clientWidth || window.innerWidth;
      var scale = Math.min(1, (vw - 32) / 1040);
      deck.style.transform = 'scale(' + scale + ')';
      stage.style.height = Math.round(600 * scale + 20) + 'px';
    }
    sizeDeck();
    setTimeout(sizeDeck, 400);
    window.addEventListener('resize', sizeDeck);

    function deal() {
      var cs = sec.querySelectorAll('.deck-card');
      cs.forEach(function (card, i) { setTimeout(function () { card.classList.add('out'); }, 140 + i * 135); });
    }
    if ('IntersectionObserver' in window) {
      var dio = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { deal(); dio.disconnect(); } }); }, { threshold: 0.3 });
      dio.observe(stage);
    } else { deal(); }
  }

  // Shopify's native dynamic-checkout ("Buy Now") button can't carry a subscription selling plan,
  // so on subscribe it silently checks out the one-time price. Fix: when a subscription option is
  // selected, hide the native Buy Now and show a custom "Buy Now" that POSTs /cart/add WITH the
  // selling_plan and return_to=/checkout — so the subscription (and its discount) carries through.
  // For one-time, the native Buy Now is shown as normal.
  function ascReadPurchaseCtx() {
    var variantId = null, sellingPlan = null, qty = 1;
    try {
      var q = new URLSearchParams(window.location.search);
      variantId = q.get('variant');
      sellingPlan = q.get('selling_plan');
    } catch (e) {}
    if (!variantId) {
      var idIn = document.querySelector('form[action*="/cart/add"] [name="id"], .product-form__buttons [name="id"], product-form [name="id"]');
      if (idIn && idIn.value) variantId = idIn.value;
    }
    if (!sellingPlan) {
      var w = document.querySelector('.appstle_subscription_wrapper');
      if (w) {
        var r = [].slice.call(w.querySelectorAll('input[type=radio]')).find(function (x) { return x.checked; });
        if (r && r.value && /^\d+$/.test(r.value)) sellingPlan = r.value;
      }
    }
    var qEl = document.querySelector('.quantity__input, [name="quantity"]');
    if (qEl && qEl.value) { qty = parseInt(qEl.value, 10) || 1; }
    return { variantId: variantId, sellingPlan: sellingPlan, qty: qty };
  }

  function buyNowSub() {
    var ctx = ascReadPurchaseCtx();
    var variantId = (ctx.variantId || '').toString().replace(/[^0-9]/g, '');
    if (!variantId) { window.location.hash = 'subscribe'; return; }
    var sellingPlan = (ctx.sellingPlan || '').toString().replace(/[^0-9]/g, '');
    var qty = parseInt(ctx.qty, 10) || 1;
    var f = document.createElement('form');
    f.method = 'POST'; f.action = '/cart/add'; f.style.display = 'none';
    function addField(name, value) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = name; i.value = value;
      f.appendChild(i);
    }
    addField('id', variantId);
    addField('quantity', String(qty));
    addField('return_to', '/checkout');
    if (sellingPlan) addField('selling_plan', sellingPlan);
    document.body.appendChild(f);
    f.submit();
  }

  function ensureSubBuyNow(nativeBuyNow) {
    var btn = document.getElementById('ascend-sub-buynow');
    if (btn) return btn;
    var container = (nativeBuyNow && nativeBuyNow.parentNode) || document.querySelector('.product-form__buttons');
    if (!container) return null;
    btn = document.createElement('button');
    btn.id = 'ascend-sub-buynow';
    btn.type = 'button';
    btn.textContent = 'Buy Now';
    var atc = document.querySelector('.product-form__submit');
    btn.className = atc ? atc.className.replace(/button--secondary|button--primary/g, '').trim() : 'button button--full-width';
    btn.style.setProperty('background', RED, 'important');
    btn.style.setProperty('color', '#fff', 'important');
    btn.style.setProperty('border', 'none', 'important');
    btn.style.setProperty('width', '100%', 'important');
    btn.style.setProperty('display', 'none', 'important');
    btn.style.setProperty('cursor', 'pointer', 'important');
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); buyNowSub(); });
    if (nativeBuyNow && nativeBuyNow.nextSibling) container.insertBefore(btn, nativeBuyNow.nextSibling);
    else container.appendChild(btn);
    return btn;
  }

  function syncBuyNowVisibility() {
    var wrap = document.querySelector('.appstle_subscription_wrapper');
    var nativeBuyNow = [].slice.call(document.querySelectorAll('.product-form__buttons button, product-form button')).find(function (b) {
      return b.id !== 'ascend-sub-buynow' && /^\s*buy\s*now\s*$/i.test(b.textContent || '');
    });
    var payMore = document.querySelector('.shopify-payment-button');
    var subSelected = false;
    if (wrap) {
      [].slice.call(wrap.querySelectorAll('.appstle_subscription_wrapper_option')).forEach(function (o) {
        var inp = o.querySelector('input[type=radio]');
        var checked = (inp && inp.checked) || o.classList.contains('appstle-selected-option') || o.classList.contains('appstle-active-option');
        if (!checked) return;
        var isOneTime = o.querySelector('.appstle_one_time_details_wrapper') || /one\s*time/i.test(o.textContent || '');
        if (!isOneTime) subSelected = true;
      });
    }
    var subBtn = wrap ? ensureSubBuyNow(nativeBuyNow) : document.getElementById('ascend-sub-buynow');
    if (nativeBuyNow) nativeBuyNow.style.setProperty('display', subSelected ? 'none' : '', 'important');
    if (payMore) payMore.style.setProperty('display', subSelected ? 'none' : '', 'important');
    if (subBtn) subBtn.style.setProperty('display', subSelected ? '' : 'none', 'important');
  }

  function syncSubHighlight() {
    syncBuyNowVisibility();
    var wrap = document.querySelector('.appstle_subscription_wrapper');
    if (!wrap) return;
    [].slice.call(wrap.querySelectorAll('.appstle_subscription_wrapper_option')).forEach(function (o) {
      var inp = o.querySelector('input[type=radio]');
      var active = (inp && inp.checked) || o.classList.contains('appstle-active-option');
      o.style.setProperty('border', '1.5px solid ' + (active ? RED : 'rgba(150,150,150,.45)'), 'important');
      o.style.setProperty('background', active ? 'rgba(240,67,43,.10)' : 'transparent', 'important');
      o.style.setProperty('border-radius', '14px', 'important');
    });
  }

  function wireSubHighlight() {
    var wrap = document.querySelector('.appstle_subscription_wrapper');
    if (!wrap || wrap.__ascHLWired) return;
    wrap.__ascHLWired = true;
    if (!document.getElementById('ascend-hl-css')) {
      var st = document.createElement('style');
      st.id = 'ascend-hl-css';
      st.textContent = '.appstle_subscription_wrapper .appstle_subscription_wrapper_option{transition:none !important;}';
      (document.head || document.documentElement).appendChild(st);
    }
    syncSubHighlight();
    var mo = new MutationObserver(function () { syncSubHighlight(); });
    mo.observe(wrap, { subtree: true, attributes: true, attributeFilter: ['class', 'checked'] });
    wrap.addEventListener('change', function () { setTimeout(syncSubHighlight, 30); }, true);
    wrap.addEventListener('click', function () { setTimeout(syncSubHighlight, 60); }, true);
  }

  function applyPurchaseIntent() {
    if (window.__ascIntentStarted) return;
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    if (params.get('onetime') !== '1') return;
    window.__ascIntentStarted = true;
    var attempts = 0;
    (function tryApply() {
      if (window.__ascIntentDone) return;
      var wrap = document.querySelector('.appstle_subscription_wrapper');
      var opts = wrap ? [].slice.call(wrap.querySelectorAll('.appstle_subscription_wrapper_option')) : [];
      var oneTimeOpt = opts.find(function (o) {
        return o.querySelector('.appstle_one_time_details_wrapper') || /one\s*time/i.test(o.textContent || '');
      });
      var radio = oneTimeOpt && oneTimeOpt.querySelector('input[type=radio]');
      if (radio) {
        if (!radio.checked) radio.click();
        window.__ascIntentDone = true;
        syncSubHighlight();
        return;
      }
      if (attempts++ < 40) setTimeout(tryApply, 250);
    })();
  }

  function boot() {
    buildInstagramSection();
    addBuyNow();
    normalizeTubs();
    injectSubscribeCSS();
    wireSubHighlight();
    syncBuyNowVisibility();
    applyPurchaseIntent();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  [400, 1200, 2500, 4000].forEach(function (d) { setTimeout(boot, d); });
  document.addEventListener('shopify:section:load', boot);
})();
